module.exports = __webpack_public_path__ + "media/audio1.936a5c1a.mp3";